import React from 'react';
import "./RecipeSearch.css";

function RecipesSearch({ setSearchInput }) {

    const changeHandler = (e) => {
        e.preventDefault();
        setSearchInput(e.target.value)
    }

    return (
        <div className="recipes-search hoverable-element">
            <form onSubmit={e => e.preventDefault()}>
                <label>Search Recipe:
                    <input key="Recipes_Search" type="text" id="Recipes_Search" name="Recipes_Search" placeholder="Search Recipe Here..." onChange={changeHandler} />
                </label>
            </form>
        </div>
    )
}

export default RecipesSearch;